import { required, optional, obj, array } from 'AppReact/schema';

const tenant = {
  id: required('integer'),
  first_name: required('string'),
  last_name: required('string'),
  tenancy_id: required('integer'),
};

export const lease = {
  actual_move_in: optional('jsDate'),
  actual_move_out: optional('jsDate'),
  id: required('integer'),
  start_date: required('jsDate'),
  end_date: required('jsDate'),
  tenants: array(obj(tenant)),
  charges: array('integer')
}

const address = {
  city: optional('string'),
  state: optional('string'),
  street: optional('string'),
  zipcode: optional('string'),
}

export const fullUnit = {
  area: optional('integer'),
  address: obj(address),
  area_rate: optional('string'),
  default_charges: array('integer'),
  default_price: optional('string'),
  feature_ids: array('integer'),
  features: array('integer'),
  floor: optional('integer'),
  building_number: optional('string'),
  floor_plan: optional('string'),
  floor_plan_id: optional('integer'),
  id: required('integer'),
  leases: array(obj(lease)),
  number: required('string'),
  status: optional('string'),
  property_id: required('integer'),
  property_name: required('string'),
}
